import { ReportPage } from 'types/reporting/reportPage';
import {
    PartyRevenueTotals,
    TopCasesByBillableHoursRow,
    TopCasesByBillableHoursTotals,
    TopCasesByInvoicedHoursRow,
    TopCasesByInvoicedHoursTotals,
    TopClientsByRevenueRow,
    TopPayersByRevenueRow,
} from 'types/reporting/executive';
import { portalAPI } from './portalAPI';
import { reportQuery } from './util/reportQuery';

const reportingExecutiveApi = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        getTopCasesByInvoicedHoursReport: reportQuery<
            ReportPage<TopCasesByInvoicedHoursRow, TopCasesByInvoicedHoursTotals>
        >(builder, '/v1/reporting/top-cases-by-invoiced-hours'),
        getTopCasesByBillableHoursReport: reportQuery<
            ReportPage<TopCasesByBillableHoursRow, TopCasesByBillableHoursTotals>
        >(builder, '/v1/reporting/top-cases-by-billable-hours'),
        getTopClientsByRevenueReport: reportQuery<ReportPage<TopClientsByRevenueRow, PartyRevenueTotals>>(
            builder,
            '/v1/reporting/top-clients-by-revenue'
        ),
        getTopPayersByRevenueReport: reportQuery<ReportPage<TopPayersByRevenueRow, PartyRevenueTotals>>(
            builder,
            '/v1/reporting/top-payers-by-revenue'
        ),
    }),
});

export const {
    useLazyGetTopCasesByInvoicedHoursReportQuery,
    useLazyGetTopCasesByBillableHoursReportQuery,
    useLazyGetTopClientsByRevenueReportQuery,
    useLazyGetTopPayersByRevenueReportQuery,
} = reportingExecutiveApi;
